import { Component, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NouveauteFormModalComponent } from './components/nouveaute-form-modal/nouveaute-form-modal.component';
import { NouveautesTableComponent } from './components/nouveautes-table/nouveautes-table.component';
import { Nouveaute, NouveauteFormData } from './nouveaute.model';
import { DeleteConfirmationModalComponent } from '../../shared/components/delete-confirmation-modal/delete-confirmation-modal.component';
import { NouveautesStore } from './nouveautes.store';

@Component({
  selector: 'app-nouveautes',
  imports: [
    TranslateModule,
    NouveauteFormModalComponent,
    NouveautesTableComponent,
    DeleteConfirmationModalComponent,
  ],
  providers: [NouveautesStore],
  templateUrl: './nouveautes.component.html',
  styleUrl: './nouveautes.component.scss',
})
export class NouveautesComponent {
  private readonly store = inject(NouveautesStore);

  readonly isLoading = this.store.isLoading;
  readonly error = this.store.error;
  readonly nouveautes = this.store.nouveautes;

  showModal = signal(false);
  showEditModal = signal(false);
  showDeleteModal = signal(false);
  selectedNouveaute = signal<Nouveaute | null>(null);
  nouveauteToDelete = signal<Nouveaute | null>(null);

  onAddNouveaute(): void {
    this.showModal.set(true);
  }

  onModalClose(): void {
    this.showModal.set(false);
  }

  onModalSubmit(data: NouveauteFormData): void {
    this.store.saveNouveaute({
      title: data.title,
      publicationDate: Math.floor(new Date(data.publicationDate).getTime() / 1000),
      version: data.version,
      status: data.status,
      sections: data.sections,
    });

    this.showModal.set(false);
  }

  onRowClick(id: string): void {
    const found = this.nouveautes().find((n) => n._id === id) ?? null;
    this.selectedNouveaute.set(found);
    this.showEditModal.set(true);
  }

  onEditModalClose(): void {
    this.showEditModal.set(false);
    this.selectedNouveaute.set(null);
  }

  onEditSubmit(data: NouveauteFormData): void {
    const id = this.selectedNouveaute()?._id;
    if (id) {
      this.store.saveNouveaute({
          _id: id,
          title: data.title,
          publicationDate: Math.floor(new Date(data.publicationDate).getTime() / 1000),
          version: data.version,
          status: data.status,
          sections: data.sections,
        });
      this.showEditModal.set(false);
      this.selectedNouveaute.set(null);
    }
  }

  onDelete(id: string): void {
    const nouveaute = this.nouveautes().find((n) => n._id === id);
    if (nouveaute) {
      this.nouveauteToDelete.set(nouveaute);
      this.showEditModal.set(false);
      this.showDeleteModal.set(true);
    }
  }

  onConfirmDelete(): void {
    const nouveaute = this.nouveauteToDelete();
    if (nouveaute) {
      this.store.deleteNouveaute(nouveaute._id);
      this.closeDeleteModal();
    }
  }

  onCancelDelete(): void {
    this.closeDeleteModal();
  }

  private closeDeleteModal(): void {
    this.showDeleteModal.set(false);
    this.nouveauteToDelete.set(null);
    this.selectedNouveaute.set(null);
  }
}
